import { render, staticRenderFns } from "./InstructorAccessAuthToggle.vue?vue&type=template&id=3eb860ac"
import script from "./InstructorAccessAuthToggle.vue?vue&type=script&lang=js"
export * from "./InstructorAccessAuthToggle.vue?vue&type=script&lang=js"
import style0 from "./InstructorAccessAuthToggle.vue?vue&type=style&index=0&id=3eb860ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports